<template>
  <div class="container">
    <div class="header">
      <van-nav-bar
        title="我的"
        left-text=""
      />
      <div class="user">
        <div>
          <img src="../assets/img/tx.png" alt="">
        </div>
        <div>
          <div class="name">{{userInfo.nikeName}}</div>
          <div class="tel">{{userInfo.mobile}}</div>
        </div>
      </div>
    </div>
    <div class="list-box">
      <div class="list" @click="changePage('contacts')">
        <div>
          <img class="list-icon" src="../assets/img/mine-txl.png" alt="">
          <span>通讯录</span>
        </div>
        <div><img class="list-arrow" src="../assets/img/sel_right.png" alt=""></div>
      </div>
      <div class="list" @click="changePage('help')">
        <div>
          <img class="list-icon" src="../assets/img/mine-help.png" alt="">
          <span>使用帮助</span>
        </div>
        <div><img class="list-arrow" src="../assets/img/sel_right.png" alt=""></div>
      </div>
      <div class="list" @click="changePage2('noticeList')">
        <div>
          <img class="list-icon" src="../assets/img/mine-gg.png" alt="">
          <span>我的公告</span>
        </div>
        <div><img class="list-arrow" src="../assets/img/sel_right.png" alt=""></div>
      </div>
    </div>

    <div class="btnbox">
      <van-button round plain type="info" size="large" @click="exit" >退出登陆</van-button>
    </div>

    <van-tabbar v-model="active">
      <van-tabbar-item @click="changePage('home')">
        <template>
          <img class="nav-img" src="../assets/img/nav1.png" />
        </template>
        <div>首页</div>
      </van-tabbar-item>
      <van-tabbar-item @click="changePage('warn')">
        <template>
          <van-badge v-if="notReadNum > 0" :content="notReadNum" max="99">
            <img class="nav-img" src="../assets/img/nav2.png" />
          </van-badge>
          <img v-else class="nav-img" src="../assets/img/nav2.png" />
        </template>
        <div>告警</div>
      </van-tabbar-item>
      <van-tabbar-item>
        <template>
          <img class="nav-img" src="../assets/img/nav3_h.png" />
        </template>
        <div class="col_b">我的</div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {saveToLocal,loadFromLocal} from '../localStorage';
  import {NavBar,Icon,Image,Toast,Loading,Button,Tabbar,TabbarItem,Badge} from 'vant';
  import Config from '@/config.js';
  let wxData=Config.wxData;
  export default {
    data() {
      return {
        active: 2,
        notReadNum:0,//未读数量
        userInfo:{}
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Button.name]:Button,
      [Tabbar.name]:Tabbar,
      [TabbarItem.name]:TabbarItem,
      [Badge.name]:Badge,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      changePage2(url){
        this.$router.push({path: url+".html",query:{code:'business-notice',title: '公告'}})
      },
      getUrlParam (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = (window.location.search.substr(1) || window.location.hash.split('?')[1])['match'](reg)
        if (r != null) return decodeURI(unescape(r[2]))
        else return null
      },
      getUserInfo() {
        axios.get("/auth/getuserinfo",{
        }).then((res)=>{
          this.userInfo = res.data;
        })
      },
      getDataObj() {
        //首页各个数据统计
        axios.get("/home/statisticsdata",{
        }).then((res)=>{
          this.notReadNum = res.data.noreadWarningCount;
        })
      },
      exit(){
        localStorage.setItem(wxData.wechatid+'account',null);
        this.changePage('login');
      },
      onClickLeft() {
      },
    },
    computed:{
    },
    created () {
      this.getDataObj();
      this.getUserInfo();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less"> 
  @import "../assets/css/default.less";
  [v-cloak]{ 
    display:none !important;
  }
</style>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;
    height: 100%;
    letter-spacing:0px;
    padding-bottom: 90px;
    background-size: 100%;
  }
  .header{
    width: 100%;
    height: 240px;
    text-align: center;
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: bold;
    background: url("../assets/img/mine-bg.png") 0 0 no-repeat;
    background-size: 100% 100%;
    .user{
      width: 100%;
      text-align: center;
      z-index: 10;
      color: #FFF;
      img{
        width: 80px;
        height: 80px;
        border-radius: 80px;
        margin-bottom: 25px;
      }
    }
    .bgimg{
      width: 100%;
      height: 250px;
      z-index: 0;
      position: absolute;
      top: 0;
      left: 0;
    }
    .name{
      margin-bottom: 10px;
    }
  }

  .list-box{
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .list{
      height: 60px;
      line-height: 60px;
      width: 100%;
      padding: 0 20px;
      background: #FFF;
      border-radius: 8px;
      border-bottom: 1px solid #ECEDEE;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .list-icon{
        width: 30px;
        margin-right: 10px;
        vertical-align: middle;
      }
      .list-arrow{
        width: 10px;
        vertical-align: middle;
      }
    }
  }

  .btnbox{
    width: 100%;
    padding: 40px 80px 0 80px;
    box-sizing: border-box;
    .van-button{
      font-size: 14px;
    }
  }

  

  /deep/.van-nav-bar{background: none;}
  /deep/.van-nav-bar__title{font-weight: bold;}
  /deep/.van-hairline--bottom::after {
    border-bottom-width: 0px;
  }

  // *************************** 底部导航样式重置 ******************************
  .van-tabbar{
    padding: 8px 0 20px 0;
    border-radius: 14px 14px 0px 0px;
    overflow: hidden;
    box-shadow: 0px 0px 6px 1px rgba(190,228,255,0.71);
  }
  /deep/.van-info{top: 5px; right: -6px;}
  .nav-img{width: 24px;margin-bottom: 4px;}
  .col_b{color: #2FAAFF;font-weight: bold;}
</style>
